/* eslint-disable max-len */

import React, { useEffect, useState } from 'react';
import { getOmjsContainer } from 'selectors';
import { AnchorLinkButton, Icons } from 'components';
import { useTranslation } from 'react-i18next';

// <li className="links-control__wrapper">
//     <AnchorLinkButton
//         icon={<Icons.IconPlay viewBox="0 0 20 20" />}
//         className='links-control__item'
//         label='Обучающее видео'
//         href='https://youtu.be/mMehJRmxh5Y'
//         target='_blank'
//         rel='noopener noreferrer'
//     />
// </li>


export const LinksListUL = () => {
    const { t, i18n } = useTranslation();
    const [ objectsReady, setObjectsReady ] = useState(false);
    const container = getOmjsContainer(false, 'links', true);

    useEffect(() => {
        if (container) {
            container.loadObjects({ fields: '*' }).done(() => {
                setObjectsReady(true);
            });
        }
    }, []);

    return objectsReady ? (
        <ul className="links-control">
            {container.objects.getArray().map(obj => {
                const a = 1;
                return obj.get('file').length > 0 ? (
                    <li className="links-control__wrapper" key={obj.id}>
                        <AnchorLinkButton
                            icon={<Icons.IconPdf viewBox="0 0 20 20" />}
                            className='links-control__item'
                            label={obj.get('name')}
                            href={obj.get('file')[0].path}
                            target='_blank'
                            rel='noopener noreferrer'
                        />
                    </li>
                ) : null;
            })}
            {/*
            <li className="links-control__wrapper">
                <AnchorLinkButton
                    icon={<Icons.IconPdf viewBox="0 0 20 20" />}
                    className='links-control__item'
                    label={t('Преимущества Ленинградской области')}
                    href={
                        i18n.language === 'ru'
                            ? 'https://map.lenoblinvest.ru/orbismap/static/content_files/lenoblinvest/9f8932f424924ca487e5be0da020fc2d.pdf'
                            : 'https://map.lenoblinvest.ru/orbismap/static/content_files/lenoblinvest/062007e7880048bf9e1e4905e8dc875d.pdf'
                    }
                    target='_blank'
                    rel='noopener noreferrer'
                />
            </li>
            {i18n.language === 'ru' && (
                <li className="links-control__wrapper">
                    <AnchorLinkButton
                        icon={<Icons.IconPdf viewBox="0 0 20 20" />}
                        className='links-control__item'
                        label={t('Функциональные возможности системы')}
                        href='https://map.lenoblinvest.ru/orbismap/static/content_files/lenoblinvest/fd9410284ed34adb97924574964c9fa7.pdf'
                        target='_blank'
                        rel='noopener noreferrer'
                    />
                </li>
            )}
            */}
        </ul>
    ) : null;
};
